<template>
  <div
    class="error-404-view w-100 h-100 d-flex justify-content-center align-items-center flex-column"
  >
    <div class="container">
      <div class="title-error-view col-12">
        <h1 class="col-12">Ops! Página não encontrada.</h1>
        <p class="col-12 mt-4">
          O endereço www.{{ baseUrl }}/<b>{{ subdomain }}</b>
        </p>
        <p class="col-12">não foi encontrada ou não existe.</p>
        <p class="col-12">
          Verifique se você digitou corretamente e tente novamente.
        </p>
      </div>
      <div class="imagem-error-view col-12 mt-4">
        <img
          alt="Página não encontrada"
          src="@/assets/images/pagina-nao-encontrada.svg"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'Error404WithoutArView',
    data: () => ({
      subdomain: '',
      baseUrl: '',
    }),

    mounted() {
      this.baseUrl = window.location.origin
        .replace('https://', '')
        .replace('http://', '')
      const subdomain = localStorage.getItem('ar-subdomain-error')
      if (subdomain) {
        this.subdomain = subdomain.replace('/', '')
      }
    },
  })
</script>
